/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useState } from 'react'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import FAQ from 'pagesNew/FAQ'
import { FaqPages } from '__generatedTypes__/globalTypes'
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import withPlatformCheck from 'HOCs/withPlatformCheck'
import * as classes from './styles'
import { Description } from './components/Description'

enum GameChallengesTabs {
  DESCRIPTION = 'Description',
  FAQ = 'FAQ',
}

type Props = {
  platform: Platform
}

const tabs = Object.values(GameChallengesTabs).map((item) => ({ id: item, title: item }))

export const GameChallenges: FC = withPlatformCheck(({ platform }: Props) => {
  const [activeTab, setActiveTab] = useState<TabsItem>(tabs[0])

  const renderTab = () => {
    const { title } = activeTab

    if (title === GameChallengesTabs.DESCRIPTION) {
      return <Description platformId={platform.id} />
    }

    if (title === GameChallengesTabs.FAQ) {
      return <FAQ page={FaqPages.Game} />
    }
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Game Challenges
      </Typography>

      <TabsNavigation<TabsItem> tabs={tabs} value={activeTab} onChange={setActiveTab} css={classes.tabs} />

      {renderTab()}
    </div>
  )
})
